//import Client from "@shaggytools/nhtsa-api-wrapper";

export var VINHelper = {
  validateVIN: function (input) {
    let response = "";

    try {
      if (input != null) {
        input = input.replaceAll(" ", "");
        if (input.length == 17) {
          response = input;
        } else if (input.length == 18) {
          var firstChar = char.toUpperCase(input[0]);
          var lastChar = char.toUpperCase(input[input.length - 1]);

          if (firstChar == "I") {
            // strip off the initial I
            response = input.Substring(1);
          } else if (!char.IsDigit(lastChar)) {
            // If the trailing character is not a digit
            // (as it should be for a valid VIN), strip it.
            // The last five characters of the vin is the
            // serial number.
            response = input.Substring(0, input.length - 1);
          }
        } else if (input.length == 19) {
          // Handle prefix + suffix
          response = input.Substring(1, 17);
        } else if (input.length == 20) {
          // Handle I + prefix + suffix
          response = input.Substring(2, 17);
        }
      }

      // If the vin includes a disallowed value, clear the response
      if (
        response.includes("I") ||
        response.includes("O") ||
        response.includes("Q")
      ) {
        response = "";
      }
      else {
        // https://en.wikipedia.org/wiki/Vehicle_identification_number#Check-digit_calculation
        // https://github.com/rfink/angular-vin
        const charAt8 = response.charAt(8);
        if (charAt8 != "X" && charAt8 != "x" && !/\d+/.test(charAt8)) response = "";
      }
    } catch (ex) {
      response = "";
    }

    return (response || "").toUpperCase();
  }
};



// WEBPACK FOOTER //
// ./src/lib/utilities/helpers/VIN.js